// @flow
import icons from '../../../assets/styles/icons.scss';
import update from 'immutability-helper/index';
import i18n from '../../../i18n';

import type { Category } from '../../../entities';

const ICON_CATEGORIES: { [string]: any }[] = [
  {
    id: 1,
    name: 'Laptops',
    icon: icons.symbolLaptop,
  },
  {
    id: 2,
    name: 'Computer Parts',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 3,
    name: 'Phones',
    icon: icons.symbolPhone,
  },
  {
    id: 4,
    name: 'Cameras & Camcorders',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 5,
    name: 'Electronics',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 6,
    name: 'Health & Supplements',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 7,
    name: 'Toys',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 8,
    name: 'Clothing',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 9,
    name: 'Other',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 10,
    name: 'Electronic Accessories', // NOTE: change me
    icon: icons.iconHappyFaceMedium,
  },
  {
    id: 11,
    name: 'Tablets',
    icon: icons.symbolTablet,
  },
  {
    id: 12,
    name: 'Shoes',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 13,
    name: 'Makeup',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 14,
    name: 'Perfume & Lotions',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 15,
    name: 'Clothing Accessories',
    icon: icons.iconHappyFaceMedium, // NOTE: change me
  },
  {
    id: 16,
    name: 'Game Consoles',
    icon: icons.symbolGame,
  },
  {
    id: 17,
    name: 'Auto Parts',
    icon: icons.symbolLaptop,
  },
];

function populateCategories(categories: Category[]): Category[] {
  return categories.map((c: Category) => {
    let icon = icons.iconCategoryOthers;
    /*let translations = {
      EN: {
        name: i18n.en['category.others'],
        type: 'item-category-translation',
      },
      ES: {
        name: i18n.es['category.others'],
        type: 'item-category-translation',
      },
    };*/

    const foundCategory = ICON_CATEGORIES.find((fc: Category) => fc.id === c.id);
    if (foundCategory) {
      icon = foundCategory.icon;
    }
    return update(c, { icon: { $set: icon } });
  });
}

function indexCategoriesById(categories: Category[]): { [key: string]: Category } {
  return categories.reduce((acum: { [key: string]: Category }, c: Category) =>
    update(acum, {
      [`${c.id}`]: {
        $set: c
      },
    }), {});
}

export {
  //DEFAULT_CATEGORIES,
  populateCategories,
  indexCategoriesById,
};



// WEBPACK FOOTER //
// ./src/modules/local-values/utils/categories.js